module.exports = __webpack_public_path__ + "img/logo.77f2d56a.png";